var _path, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMissedCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.992629 2.88179C0.716516 2.88585 0.495977 3.11298 0.500041 3.38909L0.566265 7.88861C0.570329 8.16472 0.797457 8.38526 1.07357 8.38119C1.34968 8.37713 1.57022 8.15 1.56616 7.87389L1.50729 3.87432L5.50686 3.81546C5.78297 3.81139 6.00351 3.58427 5.99945 3.30815C5.99538 3.03204 5.76825 2.8115 5.49214 2.81556L0.992629 2.88179ZM5.68791 7.23674L1.3483 3.02302L0.651675 3.74045L4.99129 7.95418L5.68791 7.23674Z",
    fill: "#FF4242"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.95457,
    y1: 7.27561,
    x2: 9.95457,
    y2: 1.27561,
    stroke: "#FF4242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissedCall);
export default __webpack_public_path__ + "static/media/missedCall.81b1cffe4143a81089e5382484d4f1e7.svg";
export { ForwardRef as ReactComponent };